"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const types = require("./types");
exports.updateRequest = (me) => ({
    me, type: types.UPDATE_REQUEST,
});
exports.updateSuccess = (me) => ({
    me, type: types.UPDATE_SUCCESS,
});
exports.updateFailure = (errorMessage) => ({
    errorMessage, type: types.UPDATE_FAILURE,
});
//# sourceMappingURL=actions.js.map